import {http_client} from "../plugins/http_client";

const getSalarioMinimo = async (queryParams) => await http_client(`/api/gestion-planilla/salario-minimo/urbano`, queryParams, 'get')

export default {
  getSalarioMinimo,
}